module.exports = __webpack_public_path__ + "static/media/relode_logo_header.a064a9b4.png";